/**
 * @author Vlad
 */
var DetailEligibilityController = (function () {
    function DetailEligibilityController(topic, $state, socket, $scope, env, _) {
        this.topic = topic;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.env = env;
        this._ = _;
        this.goeCheck = 'goeCheck';
        this.isNewOppty = false;
        this.OPP_VERSION_1 = 1;
        this.OPP_VERSION_2 = 2;
        this.OPP_VERSION_3 = 3;
        this.OPP_VERSION_5 = 5;
        this.checksData = {
            CD: undefined,
            CMR: undefined,
            DUP: undefined,
            GOE: undefined,
            NC: undefined
        };
        this.isCheckListVisible = true;
        this.getNewUIInfo = {
            uiVersion: _.get(this.topic.checksData, 'uiVersion', 1)
        };
    }
    DetailEligibilityController.prototype.$onInit = function () {
        this.getNewOppyData();
    };
    DetailEligibilityController.prototype.getNewOppyData = function () {
        var _this = this;
        var data = this.topic.checksData;
        var inbound = data.inbound;
        this.bantData = _.get(inbound, "inbound.incentiveInformation.incentiveDetail.generics", []);
        this.isCheckListVisible = !_.get(this, 'topic.checksData.isAutoEligibilityGoe', false);
        if (this.getNewUIInfo.uiVersion >= this.OPP_VERSION_2) {
            this.isNewOppty = true;
            Object.keys(this.checksData)
                .filter(function (key) { return data.result && angular.isDefined(data.result[key]); })
                .forEach(function (key) {
                _this.checksData[key] = {
                    data: data.result[key].isError ? data.result[key].error : data.result[key].data,
                    isError: data.result[key].isError
                };
            });
            if (angular.isDefined(this.checksData.CD) && angular.isDefined(this.checksData.CMR)) {
                this.checksData.CD.CMR = this.checksData.CMR.data; // Copy CMR data to CD check
            }
            if (data.result && angular.isDefined(data.result.DUP_MYSA) && angular.isDefined(data.result.DUP_SC)) {
                this.checksData.DUP = {
                    DUP_MYSA: data.result.DUP_MYSA,
                    DUP_SC: data.result.DUP_SC
                };
            }
        }
    };
    DetailEligibilityController.prototype.isDisplayHistory = function () {
        return this.topic.checksData.isAutoEligibilityGoe; // && (!this.topic.goeHistoryCheck || !this.topic.goeHistoryCheck.isPassed);
    };
    DetailEligibilityController.$inject = ['topic', '$state', 'socket', '$scope', 'env', '_'];
    return DetailEligibilityController;
}());
var DetailEligibilityComponent = (function () {
    function DetailEligibilityComponent() {
        this.templateUrl = 'detail-eligibility.html';
        this.controllerAs = 'vm';
        this.controller = DetailEligibilityController;
    }
    return DetailEligibilityComponent;
}());
angular
    .module('application')
    .component('detailEligibility', new DetailEligibilityComponent());

//# sourceMappingURL=detail.eligibility.component.js.map
